import createIcon from '../../createIcon';

/**
 * @component @name ZoomOutMap
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgM0wxNy4zIDUuM0wxNC40MSA4LjE3TDE1LjgzIDkuNTlMMTguNyA2LjdMMjEgOVYzSDE1Wk0zIDlMNS4zIDYuN0w4LjE3IDkuNTlMOS41OSA4LjE3TDYuNyA1LjNMOSAzSDNWOVpNOSAyMUw2LjcgMTguN0w5LjU5IDE1LjgzTDguMTcgMTQuNDFMNS4zIDE3LjNMMyAxNVYyMUg5Wk0yMSAxNUwxOC43IDE3LjNMMTUuODMgMTQuNDFMMTQuNDEgMTUuODNMMTcuMyAxOC43TDE1IDIxSDIxVjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ZoomOutMap = createIcon('ZoomOutMap', [
  [
    'path',
    {
      d: 'M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z',
      key: 'xdz6x0',
    },
  ],
]);

export default ZoomOutMap;
